import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import NotFoundPage from '../pages/NotFoundPage'
import { memberRoutesConfig, publicRoutesConfig, adminRoutesConfig, useMemberMenuItems, useAdminMenuItems } from '../config/routes.config'
import PublicRoute from './PublicRoute'
import UnauthorizedPage from '../pages/UnauthorizedPage'
import { UserRoles } from '../types/userRoles'
import { generateProtectedRoutes } from '../utils/routeUtils'
import { RootRedirect } from './RootRedirect'

const AppRoutes: React.FC = () => {
  const memberMenuItems = useMemberMenuItems()
  const adminMenuItems = useAdminMenuItems()

  return (
    <Routes>
      {/*----------- Root Path Redirect -----------*/}
      <Route path="/" element={<RootRedirect />} />

      {/*----------- Public Routes -----------*/}
      {publicRoutesConfig.map((route) => (
        <Route key={route.path} path={route.path} element={<PublicRoute>{route.element}</PublicRoute>} />
      ))}
      {/*----------- Member Routes -----------*/}
      {generateProtectedRoutes(memberRoutesConfig, UserRoles.MEMBER, memberMenuItems)}

      {/*----------- Admin Routes -----------*/}
      {generateProtectedRoutes(adminRoutesConfig, UserRoles.ADMIN, adminMenuItems)}

      <Route path="*" element={<Navigate to="/404" />} />
      {/*----------- 404 Not Found -----------*/}
      <Route path="/404" element={<NotFoundPage />} />
      {/*----------- 403 Unauthorized -----------*/}
      <Route path="/403" element={<UnauthorizedPage />} />
    </Routes>
  )
}

export default AppRoutes
